import axios from "axios";
import { profilerLanguageUrl, profilerUrl } from "../urls";
import { getTokenHeader, getToken } from "../../../../screen/auth/action";

const normalizeEmptyToNull = (value) => {
  if (Array.isArray(value)) {
    return value.map((item) => normalizeEmptyToNull(item));
  }

  if (value && typeof value === "object") {
    return Object.keys(value).reduce((acc, key) => {
      acc[key] = normalizeEmptyToNull(value[key]);
      return acc;
    }, {});
  }

  if (value === undefined || (typeof value === "string" && value.trim() === "")) {
    return null;
  }

  return value;
};

export const getProfilerAction = async () => {
  return new Promise(async (next) => {
    try {
      let token = await getToken();
      const response = await axios.get(profilerUrl(), getTokenHeader(token));
      return next(response.data);
    } catch (err) {
      return next({ 
        error: true, 
        message: err.response?.data?.message || 'Failed to fetch account details' 
      });
    }
  });
};

export const getModulerProfilerAction = async (module) => {
  return new Promise(async (next) => {
    try {
      let token = await getToken();
      const response = await axios.get(`${profilerUrl()}?module=${module}`, getTokenHeader(token));
      return next(response.data);
    } catch (err) {
      return next({ 
        error: true, 
        message: err.response?.data?.message || 'Failed to fetch account details' 
      });
    }
  });
};

export const UpdateProfilerAction = (data) => {
  return new Promise(async (next) => {
    let token = await getToken();
    const normalizedData = normalizeEmptyToNull(data);
    await axios
      .put(
        profilerUrl(),
        normalizedData,
        getTokenHeader(token)
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const SendProfilerAction = (data) => {
  return new Promise(async (next) => {
    let token = await getToken();
    const normalizedData = normalizeEmptyToNull(data);
    await axios
      .post(
        profilerUrl(),
        normalizedData,
        getTokenHeader(token)
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const getLanguagesAction = async () => {
  return new Promise(async (next) => {
    try {
      let token = await getToken();
      const response = await axios.get(profilerLanguageUrl(), getTokenHeader(token));
      return next(response.data);
    } catch (err) {
      return next({ 
        error: true, 
        message: err.response?.data?.message || 'Failed to fetch languages' 
      });
    }
  });
};
